import React from "react";
import { Typography } from "@material-ui/core";

function StepNavBar(props) {
  return (
    <ol className="calc-nav" aria-label="שלבי החישוב">
      {Array.isArray(props.steps)
        ? props.steps.map((step, index) => (
            <li
              aria-current={props.currentStep === index + 1 ? "step" : undefined}
              className={`${props.currentStep === index + 1 ? "is-active" : ""}${step.isFinished ? " is-finished" : ""}${
                step.isAllowed ? "" : " is-disabled"
              }`}
              key={`step-${index}`}
            >
              <button disabled={!step.isAllowed} onClick={() => props.handleStepChange(index + 1)} type="button">
                <span className="step-circle">{step.isFinished && props.currentStep !== index + 1 ? "✓" : index + 1}</span>
                <Typography component="span">{step.label}</Typography>
              </button>
            </li>
          ))
        : null}
    </ol>
  );
}

export default StepNavBar;
